module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE.b9b34d49.svg";